import fluidSVGPolyfill from "@threespot/fluid-svg-polyfill";

const init = () => {
  // Only apply to SVGs with “is-fluid” class
  document.querySelectorAll('.is-fluid').forEach( el => fluidSVGPolyfill(el) );
};

// Init on initial page load
init();

